import React from "react";
import { useNavigate } from "react-router-dom";
import { Container, Typography, Button, Box, Paper } from "@mui/material";

const PrivacyPolicyPage = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  const commonTextSx = {
    fontSize: "0.85rem",
    lineHeight: 1.9,
    fontFamily: "Roboto, sans-serif",
  };

  const sectionTitleSx = {
    fontWeight: "bold",
    fontSize: "0.95rem",
    mt: 3,
    mb: 1,
    fontFamily: "Roboto, sans-serif",
  };

  return (
    <Box
      id="PrivacyPolicy"
      sx={{
        position: "relative",
        bgcolor: "#fff",
        py: 6,
        minHeight: "100vh",
        overflowX: "hidden",
      }}
    >
      <Typography
        variant="h1"
        sx={{
          position: "absolute",
          top: { xs: "90px", sm: "59px", md: "97px", lg: "67px" },
          left: "50%",
          transform: "translateX(-50%)",
          fontSize: { xs: "3rem", sm: "5rem", md: "6rem", lg: "7rem" },
          fontFamily: "Roboto, sans-serif",
          fontWeight: "bold",
          color: "#f5cfd1",
          opacity: 0.3,
          userSelect: "none",
          zIndex: 0,
          whiteSpace: "nowrap",
        }}
      >
        Privacy policy
      </Typography>

      <Box sx={{ pt: { xs: 8, md: 12 } }}>
        <Typography
          align="center"
          sx={{
            fontWeight: "bold",
            color: "#e60033",
            fontSize: { xs: "1.3rem", md: "1.6rem" },
            fontFamily: "Roboto, sans-serif",
            mb: 0.5,
            zIndex: 2,
            position: "relative",
          }}
        >
          個人情報保護方針
        </Typography>
        <Box
          sx={{
            width: 50,
            height: 2,
            bgcolor: "#333366",
            mx: "auto",
            mb: 3,
          }}
        />
      </Box>

      <Container maxWidth="md" sx={{ mt: { xs: 4, md: 6 } }}>
        <Paper sx={{ p: { xs: 2, md: 4 }, bgcolor: "#fff6f6" }}>
          <Typography sx={commonTextSx} paragraph>
            YouProduce株式会社（以下「当社」といいます）は、個人情報の保護を重要な責務と認識し、お客様からご提供いただいた個人情報を適切に取り扱うため、以下のとおり「個人情報保護方針」を定め、これを役員および全従業員に周知徹底するとともに、確実に実行いたします。
          </Typography>

          <Typography sx={sectionTitleSx}>第1条（個人情報の定義）</Typography>
          <Typography sx={commonTextSx} paragraph>
            本方針における「個人情報」とは、個人情報保護法に定める「生存する個人に関する情報」であり、氏名、住所、電話番号、メールアドレス、勤務先情報など、特定の個人を識別できる情報をいいます。
          </Typography>

          <Typography sx={sectionTitleSx}>
            第2条（個人情報の取得と利用目的）
          </Typography>
          <Typography sx={commonTextSx} paragraph>
            当社は、資料ダウンロードやお問い合わせフォームのご利用、各種アンケート、イベント申込などを通じて、お客様から以下の情報を取得する場合があります。
            <br />
            取得する情報の例：
            <br />
            ・氏名
            <br />
            ・会社名・所属部署
            <br />
            ・役職
            <br />
            ・電話番号
            <br />
            ・メールアドレス
            <br />
            ・住所（必要に応じて）
            <br />
            ・ご利用状況やアクセス履歴（クッキー等を含む）
          </Typography>
          <Typography sx={commonTextSx} paragraph>
            利用目的：
            <br />
            1. 資料送付および関連情報のご案内
            <br />
            2. お問い合わせへの対応、フォローアップ
            <br />
            3. サービスに関するご案内（メール、電話等）
            <br />
            4. セミナー、イベント等のご案内
            <br />
            5. サービスの品質向上やマーケティング分析
            <br />
            6. 当社サービスに関する重要なお知らせの送付
            <br />
            7. ご本人確認のため
            <br />
            8. その他、上記利用目的に付随する業務の遂行
            <br />
            ※上記以外の目的で利用する場合は、事前にご本人の同意を得るものとします。
          </Typography>

          <Typography sx={sectionTitleSx}>第3条（個人情報の管理）</Typography>
          <Typography sx={commonTextSx} paragraph>
            当社は、個人情報の漏えい、滅失、毀損、不正アクセス等を防止するため、組織的・人的・物理的・技術的な安全管理措置を講じ、個人情報の適切な管理に努めます。また、個人情報を取り扱う従業員に対しては必要な教育を実施し、適正な取扱いを確保いたします。
          </Typography>

          <Typography sx={sectionTitleSx}>第4条（第三者提供の制限）</Typography>
          <Typography sx={commonTextSx} paragraph>
            当社は、法令に基づく場合を除き、ご本人の同意なく、個人情報を第三者に提供いたしません。ただし、以下の場合は除きます。
            <br />
            ・利用目的の達成に必要な範囲で業務委託先に提供する場合
            <br />
            ・統計的なデータなど、個人を識別できない形式で提供する場合
            <br />
            ・法令に基づき開示が義務づけられた場合
          </Typography>

          <Typography sx={sectionTitleSx}>第5条（業務委託先の管理）</Typography>
          <Typography sx={commonTextSx} paragraph>
            当社は、個人情報の取扱いを委託する場合には、適切な委託先を選定し、契約等を通じて必要な安全管理措置を講じ、適切に監督いたします。
          </Typography>

          <Typography sx={sectionTitleSx}>第6条（クッキー等の利用）</Typography>
          <Typography sx={commonTextSx} paragraph>
            当社のWebサイトでは、利便性の向上、アクセス状況の把握、広告配信の最適化等の目的で、クッキー（Cookie）やWebビーコンを使用することがあります。これらの技術により取得された情報は個人を特定するものではありませんが、これと他の情報を組み合わせることで個人を識別できる場合には、個人情報として適切に取り扱います。
          </Typography>

          <Typography sx={sectionTitleSx}>
            第7条（個人情報の開示・訂正・削除等）
          </Typography>
          <Typography sx={commonTextSx} paragraph>
            お客様ご本人より、当社が保有するご自身の個人情報の開示、訂正、追加、削除、利用停止、消去、第三者提供の停止等をご希望される場合には、合理的な範囲で速やかに対応いたします。なお、請求に際してはご本人確認の手続きをお願いすることがあります。
          </Typography>

          <Typography sx={sectionTitleSx}>
            第8条（プライバシーポリシーの改定）
          </Typography>
          <Typography sx={commonTextSx} paragraph>
            当社は、個人情報保護の取り組みを継続的に見直し、改善に努めます。必要に応じて、本方針を改定することがあり、改定後の内容は当社Webサイトに掲載いたします。
          </Typography>

          <Typography sx={sectionTitleSx}>第9条（お問い合わせ窓口）</Typography>
          <Typography sx={commonTextSx} paragraph>
            本方針に関するお問い合わせや、個人情報の取扱いに関するご要望等は、下記窓口までご連絡ください。
            <br />
            [個人情報に関するお問い合わせ窓口]
            <br />
            YouProduce株式会社 個人情報管理責任者
            <br />
            E-mail：contact@you-pd.com
            <br />
            受付時間：09:00〜18:00
          </Typography>

          <Box sx={{ textAlign: "center", mt: 4 }}>
            <Button
              variant="contained"
              sx={{ bgcolor: "#e60033", "&:hover": { bgcolor: "#c4002b" } }}
              onClick={handleBack}
            >
              戻る
            </Button>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default PrivacyPolicyPage;
